import { createSelector } from 'reselect';
import {
    setDefaultSource,
    getCountries
} from '../../../utils/helpers/costcenter';

import { formateSummary } from '../helper';


import { getFilterCountries } from '../../../utils/globalSelectors';

// Create select function to pick off the pieces of state we care about for this calculation
const getQuoteApprovalSelector = (state) => state.corporateQuote.approval;

const getQuoteApprovalCostCenterSelector = (state) => state.common.costcenter;

const getQuoteApprovalCountrySelector = (state) => state.common.country;

const getQuoteApprovalSummarySelector = (state) => state.corporateQuote.approval.quoteSummary;

const getQuoteApprovalProps = (approval) => {
    const {
        dateFilter,
        quotes,
        fetchingQuotes,
        totalQuotes,
        fetchingQuoteSummary
    } = approval;

    return {
        dateFilter,
        quotes,
        fetchingQuotes,
        totalQuotes,
        fetchingQuoteSummary
    }
}
const getQuoteApproval = createSelector(getQuoteApprovalSelector, getQuoteApprovalProps);

const getQuoteFromattedSummary = createSelector(getQuoteApprovalSummarySelector, //pick off a piece of state
    (quoteSummary) => formateSummary(quoteSummary) // last argument is the function that has our select logic -- in our case its pretty simple logic of extracting props.
);

const getQuoteApprovalCCAndCountryProps = (costcenter, country, countries) => {
    return setDefaultSource(
        country,
        costcenter,
        countries
    );
}

const getQuoteApprovalCCAndCountry = createSelector(getQuoteApprovalCostCenterSelector,
    getQuoteApprovalCountrySelector,
    getFilterCountries, getQuoteApprovalCCAndCountryProps);


export const getCorporateQuotesForApproval = createSelector(getQuoteFromattedSummary, getQuoteApprovalCCAndCountry, getQuoteApproval,
    (
        summary, { costcenter, country }, {
            dateFilter,
            quotes,
            fetchingQuotes,
            totalQuotes,
            fetchingQuoteSummary
        }
    ) => {
        return {
            ...summary,
            fetchingQuoteSummary,
            country,
            costcenter,
            dateFilter,
            quotes,
            fetchingQuotes,
            totalQuotes
        };
    }
);



// WEBPACK FOOTER //
// ./src/features/corporate-quote/workflow/selector.js